import React from "react";

import Logo from "../../../assets/images/smarket_logo.jpg";
import { useCreateSmartketContext } from "../create/provider/createSmartket.provider";
import { useCreateNewsSmartketContext } from "../create/news/provider/createNewsSmartket.provider";
import { useCreateUsedSmartketContext } from "../create/used/provider/createUsedSmartket.provider";
import { useLoginUser } from "../../../hooks/useLoginUser";

const Navbar = () => {
  const { setFlow, setStep, step } = useCreateSmartketContext();
  const { handleInitialState: handleInitialStateNews } =
    useCreateNewsSmartketContext();
  const { handleInitialState: handleInitialStateUsed } =
    useCreateUsedSmartketContext();
  const { logout } = useLoginUser();

  const handleLogout = () => {
    setFlow("new");
    handleInitialStateUsed();
    handleInitialStateNews();
    logout();
    setStep(1);
  };

  return (
    <nav className={`fixed z-40 w-full bg-white`}>
      <div className="max-w-screen flex h-32 px-32">
        <div className="ml-10 flex w-full items-center justify-between px-5 lg:px-0">
          <div className="-ml-7 w-24 lg:ml-0 lg:w-52">
            <img
              alt="smartket_acinco_logo"
              src={Logo}
              className="img-fluid w-full"
            />
          </div>
          {step > 2 && (
            <div className="text-center">
              <button
                type="button"
                className="text-center"
                onClick={() => handleLogout()}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
